import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Component que garante que o App Bridge seja reinicializado quando necessário
export function AppBridgeProvider({ children }) {
  const location = useLocation();

  useEffect(() => {
    // Reinicializar App Bridge se ele não estiver configurado, mas temos os parâmetros
    const urlParams = new URLSearchParams(location.search);
    const host = urlParams.get('host') || sessionStorage.getItem('shopify_host');
    const shop = urlParams.get('shop') || sessionStorage.getItem('shopify_shop');
    const apiKey = document.querySelector('meta[name="shopify-api-key"]')?.getAttribute('content');

    // Se temos os parâmetros mas o App Bridge não está funcionando
    if (host && shop && apiKey && !window.getSessionToken) {
      console.log('🔄 Reinitializing App Bridge for navigation...');
      
      // Garantir que os parâmetros estão disponíveis globalmente
      window.SHOPIFY_HOST = host;
      window.SHOPIFY_SHOP = shop;
      sessionStorage.setItem('shopify_host', host);
      sessionStorage.setItem('shopify_shop', shop);

      // Configurar App Bridge
      import('@shopify/app-bridge').then(({ default: createApp }) => {
        import('@shopify/app-bridge/utilities').then(({ getSessionToken }) => {
          try {
            const appBridgeConfig = {
              apiKey: apiKey,
              host: host,
              forceRedirect: true
            };

            const app = createApp(appBridgeConfig);
            window.appBridge = app;

            // Setup session token function
            window.getSessionToken = async () => {
              const token = await getSessionToken(app);
              return token;
            };

            console.log('✅ App Bridge reinitialized for navigation');
          } catch (error) {
            console.error('❌ Failed to reinitialize App Bridge:', error);
          }
        });
      });
    }
  }, [location]);

  return children;
}